/**
 * @deprecated These components are part of a draft UI library and are not intended for production use.
 * Please use the equivalent components from '@/components/form' instead.
 * 
 * The form-library is maintained for reference and drafting purposes only.
 */

// Field components
export { default as TextField } from './TextField';
export { default as SearchField } from './SearchField';
export { default as TeamSelector } from './TeamSelector';
export { default as TextAreaField } from './TextAreaField';
export { default as RichTextEditor } from './RichTextEditor';
export { default as EmailField } from './EmailField';
export { default as EmailValidationIndicator } from './EmailValidationIndicator';
export type { EmailValidationIndicatorProps } from './EmailValidationIndicator';
export { default as PhoneField } from './PhoneField';
export { default as PasswordField } from './PasswordField';
export { default as WebsiteField } from './WebsiteField';
export { default as ColorPickerField } from './ColorPickerField';
export { default as SelectField } from './SelectField';
export { default as MultiSelectField } from './MultiSelectField';
export { default as ComboboxField } from './ComboboxField';
export { default as YearField } from './YearField';
export { default as CurrencyField } from './CurrencyField';
export { ToggleField } from './ToggleField';
export { default as GenderField } from './GenderField';
export { default as AthleteRelationshipField } from './AthleteRelationshipField';
export { default as ParentRelationshipField } from './ParentRelationshipField';
export { default as StaffRelationshipField } from './StaffRelationshipField';
export { default as SkillSelector } from './SkillSelector';
export { default as ScheduleSelector } from './ScheduleSelector';
export { default as PhysicalAttributesInput } from './PhysicalAttributesInput';
export { JoinCodeField } from './JoinCodeField';

// Modern Location Components (Recommended)
export { 
  UniversalLocationInput,
  type UniversalLocationInputProps,
  type UniversalLocationData,
  type UniversalLocationMode
} from './UniversalLocationInput';

// Legacy Field Sets (Backward Compatibility - Consider migrating to UniversalLocationInput)
export { default as AddressFieldSet } from './AddressFieldSet';
export { default as GoogleAddressAutoComplete } from './GoogleAddressAutoComplete';
export { default as ContactFieldSet } from './ContactFieldSet';
export { default as FacilityDetailsFieldSet } from './FacilityDetailsFieldSet';
export { default as DateTimeFieldSet } from './DateTimeFieldSet';
export { default as RecurrenceFieldSet } from './RecurrenceFieldSet';

// Types
export type { AddressFieldsProps } from './AddressFieldSet';
export type { AddressData, GoogleAddressAutoCompleteProps } from './GoogleAddressAutoComplete';
export type { ContactFieldsProps } from './ContactFieldSet';
export type { FacilityDetailsProps } from './FacilityDetailsFieldSet';
export type { DateTimeFieldsProps } from './DateTimeFieldSet';
export type { RecurrenceFieldsProps } from './RecurrenceFieldSet';
export type { ComboboxOption, ComboboxFieldProps } from './ComboboxField'; 